
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { IUnitByUserPermission } from "../unitByUserPermission";


export const activeArray = [
  "Chưa kích hoạt", "Đang sử dụng"
]
export interface ICustomerTypes {
  id: number,
  title: string
  color: string
  backgroundColor: string
  code: string
  codeSymbol?: string
}
export interface ISelectOption {
  value: number
  label: string
}

export interface Phone {
  type: boolean,
  phone: string,
}
export interface IProvince {
  id: number
  areaId: number
  title: string
}

export interface IHobby {
  id: number
  title: string
}

export interface ITag {
  id: number
  title: string
  vehicleId?: number
}

export interface ICarForInfomation {
  label: string;
  total: number;
  children: {
    id: number;
    vehicleId: number
    title: string;
  }[];
}


export interface IGroup {
  title: string
  description: string
  type: number
  image: any
  nameAdmin: string
  dateCreate: string
  groupCustomerDetails: number
}

export interface ICarCompany {
  id: number
  title: string
  image: string
}
export interface ICar {
  id: number
  title: string
  image: string
  seatingCapacity: number
  carLinesTitle: string
  categoryCar: string
}

export interface IRelative {
  id: number
  title: string
}
export interface ISearchCar {
  id: number
  title: string
  typeVehicle: IRelative
  categoryCar: IRelative
  carLine: IRelative
}
export interface IStaff {
  id: number
  username: string
}
export interface IBusiness {
  id: number
  code: string
  title: string
}

export interface ITypeZNS {
  id: number
  title: string
  description: string
  image: string
}

export interface ICategoryCar {
  id: number
  title: string
  image: string
  carLine: CarLine
  typeVehicle: TypeVehicle
}

export interface CarLine {
  id: number
  title: string
}

export interface TypeVehicle {
  id: number
  title: string
}

export interface IAllCustomer {
  id: number
  code: string
  username: any
}



export interface IComplaintCategories {
  brand: string
  categoryCarId: number
  value: string
  categories: Category[]
}

export interface Category {
  id: number
  title: string
  value: string
  code: any
  complaintType: any
  role: number
  parentId: any
  level: number
  orderNumber: number
  children: Children[]
}

export interface Children {
  id: number
  title: string
  value: string
  code: any
  complaintType: any
  role: number
  parentId: number
  level: number
  orderNumber: number
  children: Children2[]
}

export interface Children2 {
  id: number
  title: string
  value: string
  code: any
  complaintType: any
  role: number
  parentId: number
  level: number
  orderNumber: number
  children: Children3[]
}

export interface Children3 {
  id: number
  title: string
  value: string
  code: any
  complaintType: any
  role: number
  parentId: number
  level: number
  orderNumber: number
  children: any[]
}










// Danh sách All KH


export const getListAllCustomerOption = async (
  limit?: number, pageNumber?: number, search?: string, unitId?: number,
  permittedCategoryCarIds?: number[]
) => {
  const path = "apiChild/listAllCustomer"
  const params = {
    limit, pageNumber, search, unitId,
    permittedCategoryCarIds
  }
  const result: ResponseSuccessTotal<IAllCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListCustomerTypes = async (search?: string) => {
  const path = "apiChild/listCustomerTypes"
  const params = { search }
  const result: ResponseSuccess<ICustomerTypes[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListRegion = async (nationwideId?: number) => {
  const path = "apiChild/listRegion"
  const params = { nationwideId }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListUnit = async (regionId?: number) => {
  const path = "apiChild/listUnit"
  const params = { regionId }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const getListDepartments = async (unitId?: number) => {
  const path = "apiChild/listDepartments"
  const params = { unitId }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const getListBusinessUnit = async () => {
  const path = "apiChild/listBusinessUnit"
  const result: ResponseSuccess<IBusiness[]> = await axiosClient.get(
    path, {}
  );
  return result;
};
export const getListGroupPermission = async () => {
  const path = "apiChild/listGroupPermission"
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, {}
  );
  return result;
};
export const getListCarColor = async (categoryCarId?: number) => {
  const params = { categoryCarId }
  const path = "apiChild/listCarColor"
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListProvince = async (search?: string) => {
  const path = "province/listProvince"
  const params = { search }
  const result: ResponseSuccess<IProvince[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListDistrict = async (search?: string) => {
  const path = "apiChild/listDistrict"
  const params = { search }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListHobby = async () => {
  const path = "hobby/listHobby"
  const result: ResponseSuccess<IHobby[]> = await axiosClient.get(
    path, {}
  );
  return result;
};

export const getListTag = async () => {
  const path = "tags/listTags"
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, {}
  );
  return result;
};

export const getListGroup = async (search?: string) => {
  const params = { search }
  const path = "groupCustomer/listGroup"
  const result: ResponseSuccess<IGroup[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListCar = async (categoryCarId?: number | null, search?: string) => {
  const params = { categoryCarId, search }
  const path = "apiChild/listCar"
  const result: ResponseSuccess<ICar[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListRelatives = async () => {
  const path = "relatives/listRelatives"
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, {}
  );
  return result;
};

export const getCLCarLines = async (categoryCarId?: number) => {
  const path = "apiChild/listCarLines"
  const params = { categoryCarId }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Danh sách loại xe
export const getCLTypeVehicle = async (carLineId?: number) => {
  const path = "apiChild/listTypeVehicle"
  const params = { carLineId }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách thương hiệu xe
export const getCLCategoryCar = async (
  carLineId?: number, typeVehicleId?: number, permittedCategoryCarIds?: number[]
) => {
  const path = "apiChild/listCategoryCar"
  const params = {
    carLineId, typeVehicleId, permittedCategoryCarIds
  }
  const result: ResponseSuccess<ICategoryCar[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách  xe
export const getSLCarsByCarLineIdAndCategoryCarId = async (
  customerId: number, carLineId?: number, categoryCarId?: number, search?: string
) => {
  const path = "apiChild/Cars"
  const params = {
    customerId, carLineId, categoryCarId, search
  }
  const result: ResponseSuccess<ICarForInfomation[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách biển số theo số khung
export const getSLVehiclePlateNumbers = async (
  customerId: number, vehicleId: number, chassisNo?: number
) => {
  const path = "apiChild/VehiclePlateNumbers"
  const params = {
    customerId, vehicleId, chassisNo
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách số khung theo biển số
export const getSLVehicleChassisNumbers = async (
  customerId: number, vehicleId: number, plateNumberId?: number
) => {
  const path = "/apiChild/VehicleChassisNumbers"
  const params = {
    customerId, vehicleId, plateNumberId
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



//Danh sách mẫu xe
export const getCLModelVehicle = async (
  typeVehicleId?: number, categoryCarId?: number, carLinesId?: number, groupVehicleId?: number,
  productVehicleId?: number

) => {
  const path = "apiChild/getListModelVehicle"
  const params = {
    typeVehicleId, categoryCarId,
    carLinesId, groupVehicleId,
  }
  const result: ResponseSuccess<ICategoryCar[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách nhóm sp
export const getCLVehicleGroup = async (
  carLineId?: number, categoryCarId?: number
) => {
  const path = "apiChild/listGroupVehicle"
  const params = {
    carLineId, categoryCarId
  }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách sp
export const getCLVehicle = async (
  carLineId?: number, typeVehicleId?: number, groupVehicleId?: number
) => {
  const path = "apiChild/listProductVehicle"
  const params = {
    carLineId, typeVehicleId, groupVehicleId
  }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách loại tương tác
export const getCLTypeInteraction = async () => {
  const path = "apiChild/listTypeInteraction"
  const params = {}
  const result: ResponseSuccess<ICarCompany[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách quốc gia
export const getCLCountry = async (limit?: number, pageNumber?: number) => {
  const path = "apiChild/listCountry"
  const params = { limit, pageNumber }
  const result: ResponseSuccess<ICarCompany[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách phiên bản xe
export const getCLVersion = async (typeVehicleId?: number, categoryCarId?: number, carLinesId?: number,) => {
  const path = "apiChild/getListVersion"
  const params = { typeVehicleId, categoryCarId, carLinesId }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách nhân vien
export const getCLStaff = async (limit?: number, pageNumber?: number, search?: string) => {
  const path = "apiChild/listStaff"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccess<IStaff[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách hạng
export const getCLRank = async (search?: string) => {
  const path = "apiChild/listStaff"
  const params = {
    search
  }
  const result: ResponseSuccess<IStaff[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//tìm kiếm xe
export const getSearchCar = async (search?: string, categoryCarId?: number) => {
  const path = "apiChild/seachCar"
  const params = {
    search, categoryCarId
  }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
// thông tin search Car
export const getInforSearchCar = async (id?: number) => {
  const path = "apiChild/infoCarHistoryCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<ISearchCar> = await axiosClient.get(
    path, { params }
  );
  return result;
};
// danh sách đại lý
export const gLAgent = async () => {
  const path = "apiChild/listAgent"
  const params = {

  }
  const result: ResponseSuccess<[]> = await axiosClient.get(
    path, params
  )
  return result
}
// danh sách nhóm màu xe
export const gGroupColorCar = async (colorId?: number) => {
  const path = "apiChild/listGroupColor"
  const params = {
    colorId
  }
  const result: ResponseSuccess<IRelative> = await axiosClient.get(
    path, { params }
  )
  return result
}
// danh sách mẫu thông báo ZNS
export const gListTypeZNS = async () => {
  const path = "apiChild/listTypeZNS"
  const params = {}
  const result: ResponseSuccess<ITypeZNS[]> = await axiosClient.get(
    path, { params }
  )
  return result
}

//api Chill dùng cho ds cớ chế mới

export interface IUnitCustomer {
  id: number
  title: string
  code: string
  level: number
}

export interface IListServiceInvoiceBranch {
  id: number
  title: string
}

export const getlistProvinceCustomer = async (search?: string, unitId?: number) => {
  const path = "apiChild/listProvinceCustomer"
  const params = {
    search, unitId
  }
  const result: ResponseSuccess<IProvince[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getlistDistrictCustomer = async (
  search?: string, unitId?: number
) => {
  const path = "apiChild/listDistrictCustomer"
  const params = {
    search, unitId
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getlistUnitCustomer = async (
  search?: string, unitId?: number
) => {
  const url = "apiChild/listUnitCustomer"
  const params = {
    search, unitId
  }
  const result: ResponseSuccess<IUnitCustomer[]> = await axiosClient.get(url, { params })
  return result
}

export const getListRankCustomer = async (
  limit?: number, pageNumber?: number, search?: string, unitId?: number
) => {
  const url = "/apiChild/listRankCustomer"
  const params = {
    limit, pageNumber, search, unitId
  }
  const result: ResponseSuccessTotal<any[]> = await axiosClient.get(url, { params })
  return result
}


export const getListServiceInvoiceBranch = async (
  search?: string, customerId?: number
) => {
  const url = "/apiChild/listServiceInvoiceBranch"
  const params = {
    search, customerId
  }
  const result: ResponseSuccess<IListServiceInvoiceBranch[]> = await axiosClient.get(url, { params })
  return result
}



export const getSLInvoices = async (
  customerId: number,
  search?: string
) => {
  const url = "apiChild/listInvoices"
  const params = {
    customerId, search
  }
  const result: ResponseSuccess<ICarForInfomation[]> = await axiosClient.get(url, { params })
  return result
}

export const getSLContracts = async (
  customerId: number,
  search?: number
) => {
  const url = "apiChild/listContracts"
  const params = {
    customerId, search
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(url, { params })
  return result
}

export const getSLCarByPlateNumber = async (
  plateNumberId: number,
) => {
  const url = "apiChild/listCarByPlateNumber"
  const params = {
    plateNumberId
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(url, { params })
  return result
}

export const getSLInfoExportDate = async (
  contractNo: number, vehicleId: number,
) => {
  const url = "apiChild/infoExportDate"
  const params = {
    contractNo, vehicleId
  }
  const result: ResponseSuccess<{ deliveryCarDate?: string }> = await axiosClient.get(url, { params })
  return result
}

export const getSLInfoPresentMileAge = async (
  invoiceNo: number, vehicleId: number,
) => {
  const url = "apiChild/infoPresentMileAge"
  const params = {
    invoiceNo, vehicleId
  }
  const result: ResponseSuccess<{ presentMileAge?: string }> = await axiosClient.get(url, { params })
  return result
}


export const getSLCarLinesByCustomer = async (
  customerId: number
) => {
  const url = "/apiChild/listCarLinesByCustomer"
  const params = {
    customerId
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(url, { params })
  return result
}

export const getSLBrandsByCustomer = async (
  customerId: number, carLineId: number
) => {
  const url = "/apiChild/listBrandsByCustomer"
  const params = {
    customerId, carLineId
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(url, { params })
  return result
}


//Danh sách xe theo hóa đơn
export const getSLCarByInvoiceNo = async (
  invoiceNo: number, customerId: number
) => {
  const url = "/apiChild/listCarByInvoiceNo"
  const params = {
    invoiceNo, customerId
  }
  const result: ResponseSuccess<ICarForInfomation[]> = await axiosClient.get(url, { params })
  return result
}

//	Danh sách xe theo hợp đồng.
export const getSLCarByContractNo = async (
  contractNo: number
) => {
  const url = "/apiChild/listCarByContractNo"
  const params = {
    contractNo
  }
  const result: ResponseSuccess<ICarForInfomation[]> = await axiosClient.get(url, { params })
  return result
}

// Danh sách mục đích sử dụng 
export const getSLPurposeOfUse = async (
  search?: string
) => {
  const url = "/apiChild/listPurposeOfUse"
  const params = {
    search
  }
  const result: ResponseSuccess<IHobby[]> = await axiosClient.get(url, { params })
  return result
}


export const getSLChildListCar = async (
  categoryCarId?: number[]
) => {
  const url = "/apiChild/listCar"
  const params = {
    categoryCarId
  }
  const result: ResponseSuccess<IHobby[]> = await axiosClient.get(url, { params })
  return result
}


//Danh sách nhân vien
export const getCLTypeVoucher = async () => {
  const path = "/apiChild/listTypeVoucher"
  const params = {

  }
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



// data Option Chi tiết KH trong modal thông tin hỗ trợ, khiếu nại



export const getCLComplaintCategories = async (
  type: number, categoryCarId?: number
) => {
  const path = "/customer/getComplaintCategories"
  const params = {
    type, categoryCarId
  }
  const result: ResponseSuccess<IComplaintCategories[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
